import { ShieldAlert, Loader2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';

type PIIExportDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  exportType: string;
  isLoading?: boolean;
};

export const PIIExportDialog = ({
  open,
  onOpenChange,
  onConfirm,
  exportType,
  isLoading = false,
}: PIIExportDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
              <ShieldAlert className="h-5 w-5 text-amber-600" />
            </div>
            <DialogTitle>PII Export Confirmation</DialogTitle>
          </div>
          <DialogDescription>
            This export of <strong>{exportType}</strong> contains personally
            identifiable information (PII) including names and email addresses.
            This action will be logged for audit purposes.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-md bg-amber-50 border border-amber-200 p-3 text-sm text-amber-800">
          By proceeding, you confirm that you have a legitimate business need to
          access this data and will handle it in accordance with our data
          protection policies.
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Exporting...
              </>
            ) : (
              'Confirm & Export'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
